import styled from 'styled-components'

export default styled.a`{
  color: black;
  text-decoration: none;
}
@media (max-width: 768px) {}
@media (max-width: 992px) {}
@media (max-width: 1200px) {}
`



// WEBPACK FOOTER //
// ./src/styles/AnchorBlack.js